import React from 'react';

import { PasswordErrors } from '../../models';
import { StyledColumn, StyledWrapper } from './styled';

type Props = {
  errors?: PasswordErrors;
  className?: string;
};

const PasswordValidationList = ({ errors, className }: Props): JSX.Element => {
  const getListClassname = (value?: boolean): string => {
    if (!errors) {
      return '';
    }

    return value ? 'success' : 'error';
  };

  return (
    <StyledWrapper className={className}>
      <StyledColumn>
        <ul>
          <li data-testid="specialCharacterCheck" className={getListClassname(errors?.hasSpecialCharacter)}>
            One special character
          </li>
          <li data-testid="uppercaseCheck" className={getListClassname(errors?.hasUppercaseCharacter)}>
            One uppercase character
          </li>
          <li data-testid="minLengthCheck" className={getListClassname(errors?.hasMinimumLength)}>
            8 characters minimum
          </li>
        </ul>
      </StyledColumn>
      <StyledColumn>
        <ul>
          <li data-testid="lowercaseCheck" className={getListClassname(errors?.hasLowerCaseLetter)}>
            One lowercase character
          </li>
          <li data-testid="numberCheck" className={getListClassname(errors?.hasNumber)}>
            One number
          </li>
          <li data-testid="passwordsQqualCheck" className={getListClassname(errors?.arePasswordsEqual)}>
            Passwords must match
          </li>
        </ul>
      </StyledColumn>
    </StyledWrapper>
  );
};

export default PasswordValidationList;
